<template>
    <b-modal ref="UpdateCBModal" no-close-on-esc no-close-on-backdrop title="Update Information" size="lg" hide-footer
        @hidden="closeModal">
        <!-- Modal content remains the same -->
        <b-row class="mb-2">
            <b-col cols="4">
                <label for="getin-due-date">Gate In Due Date</label>
                <b-form-input id="getin-due-date" type="date" v-model="localData.getin_due_date" />
            </b-col>
            <b-col cols="4">
                <label for="si-submission-date">SI Submission Date</label>
                <b-form-input id="si-submission-date" type="date" v-model="localData.si_submission_date" />
            </b-col>
            <b-col cols="4">
                <label for="vgm-submission-date">VGM Submission Date</label>
                <b-form-input id="vgm-submission-date" type="date" v-model="localData.vgm_submission_date" />
            </b-col>
            <b-col cols="4">
                <label for="tr-submission-date">TR Submission Date</label>
                <b-form-input id="tr-submission-date" type="date" v-model="localData.tr_submission_date" />
            </b-col>
            <b-col cols="4">
                <label for="liner-bl-release-status">Liner BL Release Status</label>
                <model-list-select :list="mblInvoiceStatus" id="liner_bl_release_status"
                    v-model="localData.liner_bl_release_status" option-value="value" option-text="label"
                    placeholder="Select MBL Status" />
            </b-col>
            <b-col cols="4">
                <label for="liner-bl-release-status">Line Invoice Status</label>
                <model-list-select :list="lineInvoiceStatus" id="line_inv_status" v-model="localData.line_inv_status"
                    option-value="value" option-text="label" placeholder="Select Line Invoice Status" />
            </b-col>

            <b-col md="4" v-if="localData.liner_bl_release_status == 1 && allModuleId > 0">
                <lable>B/L Type</lable>
                <model-list-select :isDisabled="true" :list="blTypeList" v-model="localData.blType"
                    option-value="blTypeVal" option-text="blTypeTxt" placeholder="Select B/L Type"></model-list-select>
                <span class="error">{{
                    errorMBLList.blType
                }}</span>
            </b-col>
            <b-col md="4" v-if="localData.liner_bl_release_status == 1 && allModuleId > 0">
                <lable>Liner Freght Terms</lable>
                <model-list-select :list="frghtTermsLinerListName" v-model="localData.frghtTermsLiner"
                    option-value="frghtTermsLinerVal" option-text="frghtTermsLinerTxt"
                    placeholder="Select Freght Terms"></model-list-select>
                <span class="error">{{
                    errorMBLList.frghtTermsLiner
                }}</span>
            </b-col>
            <b-col cols="4" v-if="localData.liner_bl_release_status == 1 && allModuleId > 0">
                <label for="mbl_release_date">MBL Release Date</label>
                <b-form-input id="mbl_release_date" type="date" v-model="localData.mbl_release_date" />
                <span class="error">{{
                    errorMBLList.mbl_release_date
                }}</span>
            </b-col>
            <b-col cols="4" v-if="localData.liner_bl_release_status == 1 && allModuleId > 0">
                <label for="mbl_date">MBL Date</label>
                <b-form-input id="mbl_date" type="date" v-model="localData.mbl_date" />
                <span class="error">{{
                    errorMBLList.mbl_date
                }}</span>
            </b-col>
            <b-col md="4" v-if="localData.liner_bl_release_status == 1 && allModuleId > 0">
                <lable>MBL Number</lable>
                <b-form-input :formatter="capitalizeAll" id="linerBLNumber" name="linerBLNumber"
                    v-model="localData.linerBLNumber"></b-form-input>
                <span class="error">{{
                    errorMBLList.linerBLNumber
                }}</span>
            </b-col>
            <b-col md="12" v-if="localData.liner_bl_release_status == 1 && JobId > 0">
                <lable>MBL Upload </lable>
                <a v-if="JobAssNo && localData.linerBLupload" style="color:purple;font-size: 12px;font-weight: 900;"
                    href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${doc_path}/${localData.linerBLupload.replaceAll('/', '_')}`)">--View Doc</a>
                <MultiFileUploader :style="`height: 79px;    background: darkgray;    width: 300px;`"
                    v-if="JobId > 0 && JobAssNo" :documentName="'Liner_BL'" :otherDocName="'Liner_BL'"
                    :folderName="'Doc Library'" :accept="'*'" :assign_no="JobAssNo" :multiple="false"
                    v-model="singleUpload" :state="Boolean(singleUpload)" :fileAllModuleId="JobId.toString()" />
                <span v-if="JobId > 0">Choose a file or drop it above...</span>
                <span class="error">{{ errorMBLList.linerBLupload }}</span>
                <br />


            </b-col>
            <b-col md="3" v-if="localData.FBLCreatedBy" class="mt-2"><b :style="'color:red;font-weight:bold;'">Created By:{{ localData.FBLCreatedBy }}</b></b-col>
            <b-col md="3" v-if="localData.FBLloginTime" class="mt-2"><b :style="'color:red;font-weight:bold;'">Created At:{{ localData.FBLloginTime | moment }}</b></b-col>
            <b-col md="3" v-if="localData.FBLupdatedBy" class="mt-2"><b :style="'color:red;font-weight:bold;'">Updated By:{{ localData.FBLupdatedBy }}</b></b-col>
            <b-col md="3" v-if="localData.FBLupdateTime" class="mt-2"><b :style="'color:red;font-weight:bold;'">Updated At:{{ localData.FBLupdateTime | moment }}</b></b-col>

        </b-row>
        <b-row class="justify-content-end">

            <b-button variant="primary" style="font-size: 0.675rem" @click="update">Update</b-button>
            <b-button variant="secondary" style="font-size: 0.675rem" @click="closeModal" class="ml-2">Cancel</b-button>
        </b-row>
    </b-modal>
</template>

<script>
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import MultiFileUploader from "../common/MultiFileUploader.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import { DateFormat, selectDateFormat } from "../../helper/filters";
export default {
    props: {
        common_id: { type: Number, default: null },
        allModuleId: { type: Number, default: null },
        JobNo: { type: String, default: null },
        booking_id: { type: Number, default: null },
        getin_due_date: { type: String, default: null },
        si_submission_date: { type: String, default: null },
        vgm_submission_date: { type: String, default: null },
        tr_submission_date: { type: String, default: null },
        liner_bl_release_status: { type: Number, default: null },
        line_inv_status: { type: Number, default: null },
        blType: { type: String, default: null },
        linerBLNumber: { type: String, default: null },
        frghtTermsLiner: { type: String, default: null },
        linerBLupload: { type: String, default: null },
        mbl_release_date: { type: String, default: null },
        mbl_date: { type: String, default: null },
    },
    data() {
        return {
            docURL: URL_BASE_DOC,
            doc_path: this.JobNo ? this.JobNo.replaceAll("/", "_") : "",
            JobAssNo: this.JobNo,
            JobId: this.allModuleId,
            lineInvoiceStatus: [
                { label: "Not Received from Line", value: 1 },
                { label: "Not Initiated", value: 0 },
                { label: "Paid", value: 2 },
                { label: "Dispute Raised", value: 3 },
                { label: "Send for Payment", value: 4 }
            ],
            mblInvoiceStatus: [
                { label: "Released", value: 1 },
                { label: "Sailed - NOT RELEASED", value: 0 },
            ],

            localData: {
                common_id: this.common_id,
                allModuleId: this.allModuleId,
                booking_id: this.booking_id,
                getin_due_date: this.getin_due_date,
                si_submission_date: this.si_submission_date,
                vgm_submission_date: this.vgm_submission_date,
                tr_submission_date: this.tr_submission_date,
                liner_bl_release_status: this.liner_bl_release_status,
                line_inv_status: this.line_inv_status,
                linerBLNumber: this.linerBLNumber,
                blType: this.blType,
                frghtTermsLiner: this.frghtTermsLiner,
                linerBLupload: this.linerBLupload,
                mbl_release_date: this.mbl_release_date,
                mbl_date: this.mbl_date,
                FBLloginTime: this.FBLloginTime,
                FBLupdateTime: this.FBLupdateTime,
                FBLCreatedBy: this.FBLCreatedBy,
                FBLupdatedBy: this.FBLupdatedBy,
            },
            singleUpload: [],
            validateMBL: true,
            invSaveMBLFlag: true,
            MBLError: [
                "Please Select BL Type",
                "Please Select Liner Freght Terms",
                "Please Enter MBL No",
                "Please Upload MBL Doc",
                "Please Enter MBL Release Date",
                "Please Enter MBL Date",
            ],
            errorMBLList: {
                blType: "",
                frghtTermsLiner: "",
                linerBLupload: "",
                linerBLNumber: "",
                mbl_release_date: "",
                mbl_date: "",
            },
            blTypeName: [
                {
                    blTypeVal: "HouseBL",
                    blTypeTxt: "House B/L",
                },
                {
                    blTypeVal: "LinerBL",
                    blTypeTxt: "Liner B/L",
                },
            ],
            frghtTermsLinerListName: [
                {
                    frghtTermsLinerVal: "Prepaid",
                    frghtTermsLinerTxt: "Prepaid",
                },
                {
                    frghtTermsLinerVal: "Collect",
                    frghtTermsLinerTxt: "Collect",
                },
            ],
        };
    },
    components: {
        ModelListSelect,
        MultiSelect,
        Multiselect,
        MultiFileUploader,
    },
    computed: {

        blTypeList() {
            return this.blTypeName;
        },
    },
    filters: {
        moment(date) {
            return DateFormat(date);
        },
    },
    created() {
        eventBus.$on("fileuploaded", (file) => {
            console.log("fileuploaded=>", file);
            this.singleUpload = file;
            this.localData.linerBLupload = file;
        });
    },
    methods: {
        validateMBLFunc() {
            let validate_new = true;
            Object.keys(this.errorMBLList).map((x, index) => {
                if (this.localData[x] == "") {
                    this.errorMBLList[x] = this.MBLError[index];
                    validate_new = false;
                }
            });
            if (validate_new != true) {
                this.validateMBL = false;
            } else {
                this.validateMBL = true;
            }
        },
        show(item) {
            console.log('JobAssNo=>', item);
            this.JobAssNo = item.JOBNO;
            this.JobId = item.allModuleId;
            this.doc_path = item.JOBNO ? item.JOBNO.replaceAll("/", "_") : "";
            this.localData = {
                common_id: item.common_id,
                allModuleId: item.allModuleId,
                booking_id: item.booking_id,
                getin_due_date: item.getin_due_date,
                si_submission_date: item.si_submission_date,
                vgm_submission_date: item.vgm_submission_date,
                tr_submission_date: item.tr_submission_date,
                liner_bl_release_status: item.liner_bl_release_status,
                line_inv_status: item.line_inv_status,
                blType: item.blType,
                frghtTermsLiner: item.frghtTermsLiner,
                linerBLNumber: item.linerBLNumber,
                linerBLupload: item.linerBLupload,
                mbl_release_date: item.mbl_release_date,
                mbl_date: item.mbl_date,
                FBLloginTime: item.FBLloginTime,
                FBLupdateTime: item.FBLupdateTime,
                FBLCreatedBy: item.FBLCreatedBy,
                FBLupdatedBy: item.FBLupdatedBy,
            }
            console.log('updatedData=>', this.localData, item);
            this.$refs.UpdateCBModal.show();
        },
        update() {
            // this.localData.blType = "LinerBL";
            if (this.localData.liner_bl_release_status == 1 && this.allModuleId > 0) {
                this.validateMBLFunc();
            }
            if (this.validateMBL != false) {
                // console.log('localData=>', this.localData);
                this.$emit('update', this.localData);
                // this.$emit('update', { ...this.localData });
                this.closeModal();
            }
        },
        closeModal() {
            this.$refs.UpdateCBModal.hide();
            this.$emit('close');
        }
    }
};
</script>


// WEBPACK FOOTER //
// UpdateCBModal.vue?60c3f47f